export default __webpack_public_path__ + "static/hcuk-80c9842ec3378b94c91f30a13f112ac9.svg";